export default "__VITE_ASSET__2d49249c__"